export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/reseller/reseller.controller.js